import React from 'react';
import { Row, Col } from '@vds/grids';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';

import Heading from '../../../common/Heading/head';
import { isPreorder, viewport, isMobile } from '../../../common/Helpers/index';
import { Body } from '../../../common/Typography/index';

const PageTitle = ({ pageInfo }) => {
  const type = viewport();
  return (
    <>
      <Row className="widthInc">
        <Col className="marginTop17 RegHeader" colSizes={{ desktop: 8, tablet: 4, mobile: 4 }}>
          <Heading size={isMobile() ? 'titleLarge' : 'titleXLarge'} heading={pageInfo.pageHeading} bold={false} />
        </Col>
      </Row>
      <Row>
        <Col colSizes={{ desktop: 1, tablet: 4, mobile: 4 }} className="RegSubHeader">
          <Body size="large"> {isPreorder() ? pageInfo.pageSubheadingPreorder : pageInfo.pageSubheading}</Body>
        </Col>
        {type === 'mobile' && (
          <Col className="marginTop35">
            <Line type="secondary" surface="light" />
          </Col>
        )}
      </Row>
    </>
  );
};

export default PageTitle;

PageTitle.propTypes = {
  pageInfo: PropTypes.string,
  pageSubheading: PropTypes.string,
};
